<template>
  <div class="row transaction">
    <div style="display: flex; align-items: center">
      <router-link
        class="btn btn-info m-2"
        to="/dashboard/add-terminal"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Add Terminal</router-link
      >
      <router-link
        class="btn btn-info m-2"
        to="/dashboard/upload-terminal"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Upload Terminal</router-link
      >
      <router-link
        class="btn btn-info m-2"
        to="/dashboard/terminal-configuration"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Terminal Configuration</router-link
      >
      <router-link
        class="btn btn-info m-2"
        to="/dashboard/terminal-remote-download"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Remote Download
      </router-link>
      <button class="btn btn-info" @click="refresh('refresh')">Refresh</button>
    </div>

    <div class="col-12 d-flex align-items-center">
      <div class="form-row align-items-center">
        <div class="col-auto mt-3">
          <!-- <label for="inlineFormInput">Select a search parameter</label> -->
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="terminalId">Terminal Id</option>
            <option
              value="walletId"
              :style="{ display: isInstitution ? 'none' : 'block' }"
            >
              Wallet Id
            </option>
            <option value="serialNo">Serial Number</option>
            <option value="merchantId">Merchant Id</option>
            <option value="salesOfficer">Sales Officer</option>
            <option value="customerCategory">Agent Category</option>
            <option value="customerName">Agent Name</option>
            <option value="configurationStatus">Configuration Status</option>
          </select>
        </div>

        <div
          class="col-auto mt-4"
          v-if="selectedValue && selectedValue !== 'configurationStatus'"
        >
          <div class="input-group mb-2">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValues[selectedValue]"
              :placeholder="`Enter ${selectedValue.replace(/Id/g, ' Id')}`"
              type="text"
            />
          </div>
        </div>

        <div
          class="col-auto mt-4"
          v-if="selectedValue === 'configurationStatus'"
        >
          <select
            class="form-control mb-2"
            v-model="searchValues[selectedValue]"
            placeholder="Select a search parameter"
          >
            <option value="">Select a configuration status</option>
            <option value="true">NOT CONFIGURED</option>
            <option value="false">CONFIGURED</option>
          </select>
        </div>

        <div class="col-auto mt-2">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('filter')"
          >
            Search
          </button>
        </div>
        <div class="col-auto mt-2">
          <button
            class="btn btn-primary mb-2 mt-4"
            @click="refresh('download')"
          >
            Download list
          </button>
        </div>
      </div>
    </div>
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Terminal ID</th>
                <!-- <th scope="col" class="text-center">Terminal ID 1</th> -->
                <th scope="col" class="text-center">Terminal Type</th>
                <!-- <th scope="col" class="text-center">Terminal Id 2</th> -->
                <th scope="col" class="text-center">Serial Number</th>
                <th scope="col" class="text-center">Merchant ID</th>
                <th scope="col" class="text-center">Agent Category</th>
                <th
                  scope="col"
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  Agent Name
                </th>
                <th scope="col" class="text-center">Business Name</th>
                <th
                  scope="col"
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  Wallet ID
                </th>
                <th scope="col" class="text-center">Configuration Status</th>

                <th
                  scope="col"
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  Sales Officer
                </th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(terminal, index) in terminals" :key="terminal._id">
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>

                <td class="text-center">{{ terminal.terminalId }}</td>
                <!-- <td class="text-center">{{ terminal.terminalId1 }}</td> -->
                <td class="text-center">{{ terminal.terminalType }}</td>
                <td class="text-center">{{ terminal.serialNo }}</td>
                <td class="text-center">{{ terminal.merchantId }}</td>
                <td class="text-center">
                  {{ terminal.tmsMerchantName || "" }}
                </td>
                <td
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  {{ terminal.agentName || "" }}
                </td>
                <td class="text-center">{{ terminal.businessName }}</td>
                <td
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  {{ terminal.walletId || "" }}
                </td>

                <td class="text-center text-uppercase">
                  <span
                    class="status"
                    :class="
                      terminal.forceConfig
                        ? 'status-disabled'
                        : 'status-enabled'
                    "
                  >
                    {{
                      terminal.forceConfig ? "NOT CONFIGURED" : "CONFIGURED"
                    }}</span
                  >
                </td>

                <td
                  class="text-center"
                  :style="{ display: isInstitution ? 'none' : 'table-cell' }"
                >
                  {{ getSalesOfficerName(terminal.salesOfficerId) || "N/A" }}
                </td>
                <td class="text-center">
                  <!-- <drop-down class="nav-item" title="Options" id="list">
                    <div class="p-2">                         -->
                  <router-link
                    :to="`/dashboard/view-terminal/${
                      terminal.terminalId
                        ? terminal.terminalId
                        : terminal.serialNo
                    }`"
                    >View Details</router-link
                  >
                  <!-- </div>
                  </drop-down> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";

export default {
  props: [""],
  data() {
    return {
      error: false,
      terminals: [],
      errorMsg: "",
      loading: false,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      currentPage: 1,
      totalDocs: 0,
      limit: 50,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      searchValues: {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
      },
      selectedValue: "",
      download: false,
      userType: localStorage.getItem("userType"),
      allSalesOfficers: [],
    };
  },
  computed: {
    ...mapState(["utils"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      // return this.userType === 'super-admin';
    },
  },
  methods: {
    ...mapActions(["getMerchants"]),
    async refresh(mode) {
      try {
        this.loading = true;
        this.errorMsg = "";
        this.error = false;
        let payload = {
          page: this.page,
          ...this.searchValues,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "refresh":
            this.currentPage = 1;
            payload = { page: this.page };
            this.selectedValue = "";
            this.searchValues = "";
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/terminals/get`,
          payload,
        );
        if (mode === "download") {
          // const csvTran = convertArrayToCSV(res.data.terminals);
          // fileDownload(csvTran, "terminals.csv");

          const formattedTerminals = res.data.terminals.map((terminal) => ({
            ...terminal,
            salesOfficer: this.getSalesOfficerName(terminal.salesOfficer),
          }));

          const csvTran = convertArrayToCSV(formattedTerminals);

          fileDownload(csvTran, "terminals.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.terminals;
          this.terminals = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Terminals";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        salesOfficer: "",
        customerCategory: "",
        customerName: "",
      };
    },

    getMerchantName(id) {
      const merchant = this.utils.merchants.filter((el) => el._id === id);
      return merchant.length !== 0 ? merchant[0].merchantName : "";
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },
  },
  watch: {
    selectedValue() {
      this.clearSearchFields();
      this.refresh();
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/terminals/get`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.terminals;
      this.terminals = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Terminals";
    }
    this.loading = false;
    this.getMerchants();
    this.getSalesOfficers();
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}
</style>
